import { ITypeTicketData } from 'meta/pages/v4/typeticket'
import { useAppSelector } from 'store'
import { TypeTicketSelectors } from 'store/pages/typeticket'

export const useTypeTicketData = ({ id }: { id: number }): ITypeTicketData | undefined =>
  useAppSelector(TypeTicketSelectors.getTypeTicketData({ id }))

export const useTypeTicketsCollectionIdsForGivenEvent = ({ eventId }: { eventId: number }): number[] | undefined =>
  useAppSelector(TypeTicketSelectors.getUserTypeTicketCollectionIdsForGivenEvent({ eventId }))
